export default __webpack_public_path__ + "static/media/686.ecb380e5.gif";